<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="维护交期"
      width="1000px"
      append-to-body
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="noticeDelivery"
        class="form"
        label-width="110px"
        style="height: 200px;">
      <el-row>
        <el-col :span="12">
          <el-form-item label="类型">
            <el-select v-model="noticeDelivery.finalDeliveryType">
              <el-option label="生产延期" value="生产延期" default/>
              <el-option label="业务同意延期" value="业务同意延期"/>
              <el-option label="物料延期" value="物料延期"/>
              <el-option label="产能瓶颈" value="产能瓶颈"/>
              <el-option label="业务提前推发货 未到期" value="业务提前推发货 未到期"/>
              <el-option label="其他" value="其他"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最终交期">
            <el-date-picker
                v-model="noticeDelivery.finalDeliveryDate"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="请选择"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="描述">
            <el-input
                v-model="noticeDelivery.finalDeliveryDesc"
                type="textarea"
                style="min-height: 80px;"
                autosize
                placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        disabled: "",
        noticeDelivery: {
          pkid: 0,
          finalDeliveryDate: "",
          finalDeliveryType: "生产延期",
          finalDeliveryDesc: "",
        },
      };
    },

    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.noticeDelivery = row;
        }
      },
      inputHandle(row, index) {
        this.$set(this.model.detailVOS, index, row);
      },
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "taskDispatchBills/updateDeliveryDate", this.noticeDelivery)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 8px;
  padding-bottom: 5px;
}
</style>
